<template>
	<div>
		<div style="padding:60px;">
			<div class="goods-spec">
				<span>商品规格</span>
				<el-link type="primary" @click="addPrivateSpec" class="goods-spec-add">添加规格</el-link>
			</div>
			<div class="goods-container" v-for="(attr, index) in privateGoodsItem" :key="index">
				<div class="goods-content">
					<div class="goods-content-box">
						<div class="goods-content-left">
							<el-form label-width="80px" style="width:400px">
								<el-form-item label="规格名">
									<el-input v-model="attr.privateSpecName" placeholder="请输入规格名"></el-input>
								</el-form-item>
								<el-form-item label="规格值">
									<el-tag v-for="tag in attr.dynamicTags" :key="tag" closable @click="ChangeTag(tag,attr)"
										:disable-transitions="false" @close="handleClose(tag, attr)">
										{{ tag }}
									</el-tag>
									<el-input class="input-new-tag" v-if="attr.inputVisible" v-model="attr.inputValue"
										:ref="`saveTagInput${index}`" size="small"
										@keyup.enter.native="handleInputConfirm(attr.inputValue, attr)"
										@blur="handleInputConfirm(attr.inputValue, attr)">
									</el-input>
									<el-button v-else class="button-new-tag" size="small"
										@click="showInput(attr, index)">+ 添加</el-button>
								</el-form-item>
							</el-form>
						</div>
						<div class="goods-content-right">
							<el-link type="danger" @click="delPrivateSpec(index)">删除规格</el-link>
						</div>
					</div>
				</div>
			</div>
			
			<p style="margin:24px 0 10px 0">价格 / 库存</p>
			<el-table ref="multipleTable" :data="tableColumnList.tableBodyList" stripe tooltip-effect="dark"
				style="width: 100%;margin-top:1%;">
				<el-table-column :label="item.propName" :property="item.prop"
					v-for="item in tableColumnList.tableHeaderList" :key="item.prop" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row[scope.column.property] }}</span>
					</template>
				</el-table-column>
				<el-table-column label="价格（元）">
					<template slot-scope="scope">
						<el-input v-model.number="scope.row.price"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="库存">
					<template slot-scope="scope">
						<el-input v-model.number="scope.row.stock"></el-input>
					</template>
				</el-table-column>
				<!-- <el-table-column label="库存预警">
					<template slot-scope="scope">
						<el-input v-model.number="scope.row.low_stock"></el-input>
					</template>
				</el-table-column> -->
			</el-table>
			
		</div>
	</div>
</template>
<script>
	export default {
		name: 'Edit',
		props: {
			id: String,
			goods_item: [Object,Array],
			body_list:[Object,Array],
		},
		data() {
			return {
				tableColumnList: {
					tableHeaderList: [],
					tableBodyList: []
					// inventory: ''
				},
				privateGoodsItem: [{
					"privateSpecName":"",
					"dynamicTags":[],
					"inputVisible":false,
					"inputValue":"",
				}],
				judge:0,
			}
		},
		computed: {
			// 计算规格
			calculateAttribute() {
				// 初始化
				let obj = {}
				this.privateGoodsItem.forEach((item) => {
					// 判断有没有输入规格名
					if (item.privateSpecName) {
						//规格名:规格值     //'颜色':'尺寸'
						obj[item.privateSpecName] = item.dynamicTags
					}
				})
				return obj
			}
		},
		watch: {
			// 监听规格数据
			calculateAttribute(newVal) {
				let cloneNewVal = JSON.parse(JSON.stringify(newVal))
				let attrName = [] //规格名数组
				let attrValue = [] //规格值数组
				for (let key in cloneNewVal) {
					attrName.push(key)
					attrValue.push(cloneNewVal[key])
				}

				// 表格内容数据（笛卡尔积算法）
				let finalArr = this.cartesianProductOf(...attrValue)

				let tableObj = {
					tableBodyList: [],
					tableHeaderList: []
				}
				let self=this;
				// 表格内容
				tableObj.tableBodyList = finalArr.map((item) => {
					let obj = {
						price: 0,
						stock: 0,
						low_stock: 0
					}
					let attr_name_obj={};
					for (let i = 0; i < item.length; i++) {
						attr_name_obj[attrName[i]] = item[i];
						obj[attrName[i]] = item[i]
					}
					if(self.tableColumnList.tableBodyList!=""){
						
						let judge=0;
						for(let key in self.tableColumnList.tableBodyList){
							let have_name_obj={};
							for(let key1 in self.tableColumnList.tableBodyList[key]){
								if(key1!="price" && key1!="stock" && key1!="low_stock"){
									have_name_obj[key1] = self.tableColumnList.tableBodyList[key][key1]
								}
							}
							if(self.isEqual(attr_name_obj,have_name_obj)){
								// let aa={ "颜色": "红", "尺码": "m", "大小": "2" };
								// if(self.isEqual(attr_name_obj,aa)){
								// 	console.log(attr_name_obj,have_name_obj,aa,self.tableColumnList.tableBodyList[key])
								// }
								obj['price']=self.tableColumnList.tableBodyList[key]['price'];
								obj['stock']=self.tableColumnList.tableBodyList[key]['stock'];
								judge="1";
							}
							
							if(judge=="1"){
								break;
							}
						}
					}
					return obj
				});
				this.tableColumnList.tableBodyList = tableObj.tableBodyList //表格内容数据

				// 表头
				let skuTableArr = Object.keys(newVal)
				tableObj.tableHeaderList = skuTableArr.map((item) => {
					return {
						prop: item,
						propName: item
					}
				})
				this.tableColumnList.tableHeaderList = tableObj.tableHeaderList // 表头
				if(this.judge==0 && this.body_list!=""){
					this.judge++;
					this.tableColumnList.tableBodyList=this.body_list;
				}
			}
		},

		methods: {
			ChangeTag(tag,attr){
				let that=this;
				this.$prompt('请输入修改的数据', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				}).then(({ value }) => {
				  for(var i=0;i<attr.dynamicTags.length;i++){
				  	if(attr.dynamicTags[i]==tag){
				  		attr.dynamicTags[i]=value;
						attr.inputVisible = false
						attr.inputValue = ''
						break;
				  	}
				  }
				}).catch(() => {
				});
			},
			isEqual(obj1,obj2){
				if(!obj1 instanceof Object || !obj2 instanceof Object){/*  判断不是对象  */
					return obj1 === obj2;
				}
				if(Object.keys(obj1).length !== Object.keys(obj2).length){
					return false;
					//Object.keys() 返回一个由对象的自身可枚举属性(key值)组成的数组,判断键值个数是否相等
				}
				for(var attr in obj1){//逐个值进行判断
					if(obj1[attr] instanceof Object && obj2[attr] instanceof Object){
						return isEqual(obj1[attr],obj2[attr]);//如果值为对象再递归进行判断
					}else if(obj1[attr] !== obj2[attr]){
						return false;
					}
				}
				return true;
			},
			
			// 添加规格
			addPrivateSpec(index) {
				this.privateGoodsItem.push({
					privateSpecName: '',
					dynamicTags: [],
					inputVisible: false,
					inputValue: ''
				})
			},
			delPrivateSpec(index) {
				this.privateGoodsItem.splice(index, 1)
			},
			handleInputConfirm(val, attr) {
				if (val) {
					attr.dynamicTags.push(val)
				}
				attr.inputVisible = false
				attr.inputValue = ''
			},
			handleClose(tag, item) {
				item.dynamicTags.splice(item.dynamicTags.indexOf(tag), 1)
			},
			showInput(attr, index) {
				attr.inputVisible = true
				this.$nextTick((_) => {
					this.$refs[`saveTagInput${index}`][0].$refs.input.focus()
				})
			},
			// 笛卡尔积算法
			cartesianProductOf(...args) {
				return args.reduce(
					(total, current) => {
						let ret = []
						total.forEach((a) => {
							current.forEach((b) => {
								ret.push(a.concat([b]))
							})
						})
						return ret
					},
					[
						[]
					]
				)
			}
		},
		mounted() {
			
			if(this.goods_item!="" && this.goods_item!=undefined){
				this.privateGoodsItem=this.goods_item;
			}
		}
	}
</script>
<style scoped="scoped">
	.goods-spec {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.goods-spec .goods-spec-add {
		margin-right: 15px;
	}

	.goods-container .button-new-tag {
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.goods-container .input-new-tag {
		width: 90px;
		margin-right: 10px;
		vertical-align: bottom;
	}

	.goods-container .el-tag {
		margin-right: 10px;
	}

	.goods-container .goods-content {
		margin-bottom: 10px;
		padding: 14px;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		background-color: #fcfcfc;
	}

	.goods-content .goods-content-box {
		display: flex;
		align-items: center;
	}

	.goods-content-box .goods-content-left {
		flex: 1;
	}
</style>
